/* global angular */

(function () {
    "use strict";

    var app = angular.module('app');

    app.controller('AuthCtrl', ['$rootScope', '$scope', '$controller', 'State', 'api', 'Upload', 'Account', 'FacebookService', 'gtm', 'Wishlist', 'CONFIG', function ($rootScope, $scope, $controller, State, api, Upload, Account, FB, gtm, Wishlist, CONFIG) {

        $controller('FormCtrl', {
            $scope: $scope
        });

        var state = new State(),
            stateLogin = new State(),
            stateSignUp = new State(),
            stateForgot = new State(),
            stateFacebook = new State();

        var loc = CONFIG.app.locale;
        var model = {
            setPsw: true,
            _targets: null //temp private property
        };
        var viewbag = {
            forgotting: false
        };
        var data = {
            birthDate: {
                value: null,
                days: function () { return Array.apply(null, Array(new Date(this.year || new Date().getFullYear(), this.month || 0, 0).getDate())).map(function (_, i) { return i + 1 }) },
                day: null,
                months: Array.apply(null, Array(12)).map(function (_, i) { return i + 1; }),
                month: null,
                years: Array.apply(null, Array(90)).map(function (_, i) { return new Date().getFullYear() - 10 - i; }),
                year: null,
                onChange: function () { this.value = !this.day || !this.month || !this.year ? null : new Date(Date.UTC(this.year, this.month - 1, this.day, 12)) }
            }
        };

        Account.getUser().then(function (user) {
            model.user = user;
            state.ready();
        });

        function getRegisterData() {
            api.data.register().then(function (response) {
                angular.extend(data, response.data);
            });
        }

        function getEditData() {
            api.user.detail().then(function (response) {
                angular.extend(model.user, response.data);

                model.setPsw = false;

                if (model.user.birthDate) {
                    model.user.birthDate = new Date(model.user.birthDate);
                    data.birthDate.day = model.user.birthDate.getDate();
                    data.birthDate.month = model.user.birthDate.getMonth() + 1;
                    data.birthDate.year = model.user.birthDate.getFullYear();
                }

                var t = model.user.targets.split(",");
                for (var i in t)
                    if (t[i] != "")
                        addTarget(parseInt(t[i]));

                model.isCoach = model.user.profile == 2;

            });
            getRegisterData();
        }

        function addTarget(id) {
            if (!model._targets) model._targets = {};
            if (model._targets[id]) {
                delete model._targets[id];
                if (Object.keys(model._targets).length == 0) model._targets = null;
            }
            else
                model._targets[id] = true;

            // fill model
            var _tmp = "", _keys = Object.keys(model._targets);
            for (var i = 0; i < _keys.length; i++) {
                _tmp += ',' + _keys[i];
            }
            if (_tmp != "")
                _tmp += ',';
            model.user.targets = _tmp;
        }

        function onUploadFileSelected(file, newFiles) {
            if (!file) {
                return;
            }
            Array.isArray(file) ? file = file[0] : null;
            model.avatarBase64 = null;
            Upload.resize(file, 512, 512, .9, 'image/jpeg', null, true).then(function (resized) {
                Upload.dataUrl(resized, true).then(function (url) {
                    model.avatarBase64 = url;
                });
            });
        }


        function signin() {
            if (stateLogin.busy()) {
                api.user.login(model.user).then(function (response) {
                    stateLogin.success();                    
                    gtm.push({
                        event: 'Login',
                        user: response.data.id,                        
                        user_type: response.data.profile
                    });
                    onPostLogin(response.data);
                }, function (error) {
                    stateLogin.error(error);
                });
            }
        }

        function onPostLogin(user) {
            Account.setUser(user);
            Wishlist.get();
            $rootScope.$broadcast('onAuthUserChange');
            //$rootScope.$broadcast('loadUserModal');
            location.href = CONFIG.app.pages.home;
        }
         
        function loginFb() {
            if (stateFacebook.busy()) {
                FB.login().then(function (response) {
                    stateFacebook.success();
                    if (response.status === 'connected')
                        api.user.loginFb(response.authResponse.accessToken).then(function (response) {
                            gtm.push({
                                event: 'FacebookLogin',
                                user: response.data.id,
                                user_type: response.data.profile
                            });
                            onPostLogin(response.data);
                        }, function (error) {
                            stateFacebook.error(error);
                        });
                }, function (error) {
                    stateFacebook.error(error);
                });
            }
        }

        function forgot() {
            if (stateForgot.busy()) {                
                api.user.forgot(model).then(function (response) {
                    stateForgot.success();
                    gtm.push({
                        event: 'ForgotPsw'
                    });
                }, function (error) {
                    model.emailNotFound = model.email;
                    stateForgot.error(error);
                });
            }
        }

        function register() {
            if (stateSignUp.busy()) {
                onPreSignUp(model);
                api.user.register(model).then(function (response) {
                    stateSignUp.success();                      
                    var user = response.data;
                    gtm.push({
                        event: 'Register',
                        user: user.id,
                        user_type: user.profile
                    });
                    // autologin  
                    //signin();
                    //location.href = "/";
                }, function (error) {
                    stateSignUp.error(error);
                });
            }
        }

        function edit() {
            if (stateSignUp.busy()) {
                onPreSignUp(model);
                api.user.edit(model).then(function (response) {
                    stateSignUp.success();
                }, function (error) {
                    stateSignUp.error(error);
                });
            }
        }

        function editPassword() {
            if (stateSignUp.busy()) {                
                api.user.editPassword({ tokenEncoded: model.tokenEncoded, email: model.user.email, password: model.user.password }).then(function (response) {
                    stateSignUp.success();
                }, function (error) { 
                    stateSignUp.error(error);
                });
            } 
        }

        function deleteAccount() {
            if (stateSignUp.busy()) { 
                api.user.delete({ tokenEncoded: model.tokenEncoded, email: model.user.email }).then(function (response) {
                    stateSignUp.success();
                }, function (error) {
                    stateSignUp.error(error);
                });  
            }
        }

        function onPreSignUp(model) {
            if (model.user.birthDate) {
                model.user.birthDate = new Date(Date.UTC(model.user.birthDate.getFullYear(), model.user.birthDate.getMonth(), model.user.birthDate.getDate(), model.user.birthDate.getHours()));
            }
            if (data.birthDate && data.birthDate.value) {
                model.user.birthDate = data.birthDate.value;
            }
        }    
       
        function logout() {
            if (stateLogin.busy()) {
                api.user.logout().then(function () {                    
                    gtm.push({
                        event: 'Logout',
                        user: Account.user.id,
                        user_type: Account.user.profile
                    });
                    stateLogin.success();
                    Account.setUser(null);
                    Booking.getCart();
                    $rootScope.$broadcast('onAuthUserChange');
                    // Wishlist.empty();
                    // FB.logout();       
                    location.href = CONFIG.app.pages.home;

                    if ($scope.modal) {
                        $scope.modal.reject(null);
                    }
                });
            }
        }

        $scope.state = state;
        $scope.stateLogin = stateLogin;
        $scope.stateSignUp = stateSignUp;
        $scope.stateForgot = stateForgot;
        $scope.stateFacebook = stateFacebook;
        $scope.loc = loc;
        $scope.model = model;
        $scope.data = data;
        $scope.getRegisterData = getRegisterData;
        $scope.getEditData = getEditData;
        $scope.addTarget = addTarget;        
        $scope.onUploadFileSelected = onUploadFileSelected;

        $scope.signin = signin;
        $scope.loginFb = loginFb;
        $scope.forgot = forgot;
        $scope.register = register;
        $scope.edit = edit;
        $scope.editPassword = editPassword;
        $scope.deleteAccount = deleteAccount;
        $scope.logout = logout;
        $scope.viewbag = viewbag;        

    }]);

    app.service('Account', ['$q', 'api', 'SessionStorage', 'CONFIG', function ($q, api, storage, CONFIG) {
        var service = this;
        var key = 'user';
        var user = null;

        function getUser(refresh) {
            var deferred = $q.defer();
            if (!refresh && !storage.exists(key)) {
                refresh = true;
            }
            if (refresh) {
                api.user.me().then(function (response) {
                    setUser(response.data || null);
                    deferred.resolve(user);
                }, function (error) {
                    setUser(null);
                    deferred.resolve(user);
                });
            } else {
                setUser(storage.get(key));
                deferred.resolve(user);
            }
            return deferred.promise;
        }

        function setUser(data) {
            user = data;
            storage.set(key, data);
            service.user = user;
        }

        function getShortName() {
            return user.firstName.substr(0, 1) + '. ' + user.lastName;
        }

        function isLogged() {
            return user !== null;
        }

        this.user = user;
        this.getUser = getUser;
        this.setUser = setUser;
        this.getShortName = getShortName;
        this.isLogged = isLogged;
    }]);

    app.factory('FacebookService', ['$q', 'CONFIG', function ($q, CONFIG) {

        function FacebookService() { }

        function onFacebookStatus(response, deferred, init) {
            FacebookService.authResponse = null;
            if (response.status === 'connected') {
                FacebookService.authResponse = response.authResponse;
                deferred.resolve(response);
            } else if (response.status === 'not_authorized') {
                if (init) {
                    deferred.resolve(response);
                } else {
                    deferred.reject(response);
                }
            } else {
                deferred.reject(response);
            }
        }

        FacebookService.FB = function () {
            var deferred = $q.defer();
            if (window.FB !== undefined) {
                deferred.resolve(window.FB);
            } else {
                FacebookService.init().then(function (success) {
                    deferred.resolve(window.FB);
                }, function (error) {
                    deferred.reject(error);
                });
            }
            return deferred.promise;
        };

        FacebookService.getFacebookMe = function () {
            var deferred = $q.defer();
            FacebookService.FB().then(function (facebook) {
                facebook.api('/me', { fields: 'id,name,first_name,last_name,email,gender,picture,cover,link' }, function (response) {
                    if (!response || response.error) {
                        deferred.reject('Error occured');
                    } else {
                        deferred.resolve(response);
                    }
                });
            });
            return deferred.promise;
        };

        FacebookService.getPictureMe = function () {
            var deferred = $q.defer();
            FacebookService.FB().then(function (facebook) {
                facebook.api('/me/picture', { width: 300, height: 300, type: 'square' }, function (response) {
                    if (!response || response.error) {
                        deferred.reject('Error occured');
                    } else {
                        deferred.resolve(response);
                    }
                });
            });
            return deferred.promise;
        };

        FacebookService.login = function () {
            var deferred = $q.defer();
            FacebookService.FB().then(function (facebook) {
                facebook.login(function (response) {
                    onFacebookStatus(response, deferred);
                }, {
                        scope: 'public_profile, email' // publish_stream,
                    });
            });
            return deferred.promise;
        };

        FacebookService.logout = function () {
            var deferred = $q.defer();
            FacebookService.FB().then(function (facebook) {
                facebook.logout(function (response) {
                    deferred.resolve(response);
                });
            });
            return deferred.promise;
        };

        FacebookService.init = function () {
            var deferred = $q.defer();
            window.fbAsyncInit = function () {
                FB.init({
                    appId: CONFIG.app.FACEBOOK_APP_ID,
                    status: true,
                    cookie: true,
                    xfbml: true,
                    version: 'v2.12'
                });
                deferred.resolve(FB);
            };
            try {
                (function (d, s, id) {
                    var js, fjs = d.getElementsByTagName(s)[0];
                    if (d.getElementById(id)) { return; }
                    js = d.createElement(s);
                    js.id = id;
                    js.src = "//connect.facebook.net/en_US/sdk.js";
                    fjs.parentNode.insertBefore(js, fjs);
                }(document, 'script', 'facebook-jssdk'));
            } catch (e) {
                deferred.reject(e);
            }
            return deferred.promise;
        };

        FacebookService.init();

        return FacebookService;
    }]);

}());